import { api } from "./api";

const tokenPublicStaging =
  "Basic NjM1YWUwNmY4Y2Y1OGU0MTFlZWIwYjhlOjYzNGQyN2QwOTI3MWYzMzdiMzlmMTQ1OQ==";
const tokenPublicProd =
  "Basic NjMyYjU2YzE1NDVkZDA3Njc2NjIxNzA5OjYzNGQyN2QwOTI3MWYzMzdiMzlmMTQ1OQ==";

export async function getFaq(): Promise<any[]> {
  try {
    const { data } = await api.get(`database/faq__c`, {
      headers: {
        Authorization: !!window.location.href.match(
          /(funifier\.app|localhost)/gi
        )
          ? tokenPublicStaging
          : tokenPublicProd,
      },
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function fetchMissions(player: string, region?: string) {
  try {
    const { data } = await api.post(`find/missions`, { region, player });
    if (Array.isArray(data) && data.length > 0) {
      return data[0];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function fetchLifeQuest(
  player: string,
  region?: string,
  lifeskill?: string
) {
  try {
    const { data } = await api.post(`find/lifequest`, {
      region,
      player,
      lifeskill,
    });
    return data;
  } catch (e) {
    throw e;
  }
}

export async function fetchContentInfo(ids: any) {
  try {
    const { data } = await api.post(`find/content`, ids);
    if (Array.isArray(data) && data.length > 0) {
      return data[0];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}
